export const getAccountMenuBorder = theme => {
  return `${theme.borderWidth['100']} solid ${theme.color['border-core-default']}`;
};
export const getAccountMenuItemPadding = theme => {
  return `${theme.space['250']} ${theme.space['500']}`;
};